// Import Vue
import Vue from 'vue';
import Vuex from 'vuex';

// Import F7
import Framework7 from 'framework7';

// Import F7 Vue Plugin
import Framework7Vue from 'framework7-vue';

// OR for Material Theme:
import Framework7Theme from 'framework7/dist/css/framework7.material.min.css';
import Framework7ThemeColors from 'framework7/dist/css/framework7.material.colors.min.css';
import Framework7ThemeRtl from 'framework7/dist/css/framework7.material.rtl.min.css';

// Import App Custom Styles
import AppStyles from './css/app.css';

// Import Routes
import Routes from './routes.js';

// Import App Component
import App from './app';

// Init F7 Vue Plugin
Vue.use(Framework7Vue);
Vue.use(Vuex);

// Init axios and VueAxios
import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios);

String.prototype.replaceArray = function (find, replace) {
    let replaceString = this;
    let regex;
    for (let i = 0; i < find.length; i++) {
        regex = new RegExp(find[i], "g");
        replaceString = replaceString.replace(regex, replace[i]);
    }
    return replaceString;
};

function MyList(init) {
    this.init = init;

    this.clear = function () {
        this.total = null;
        this.current_page = 1;
        this.data = null;
        this.params = {order: {column: '', direction: ''}, filters: {}, q: ''};

        if (this.init)
            this.fields = this.init.fields;
        else
            this.fields = [];
    };

    this.clear();
}

// Init App
new Vue({
    el: '#app',
    template: '<app/>',
    // Init Framework7 by passing parameters here
    framework7: {
        root: '#app',
        material: true,
        routes: Routes,
    },
    // Register App Component
    components: {
        app: App
    },
    mounted: function () {
        let self = this;

        self.$store.dispatch('CSRF_TOKEN');

        if (self.$store.state._debug === true)
            f7.$store = self.$store;
    },
    created: function () {
        // Use only on development mode
        //window.vm = this;
    },
    data: function () {
      return {
          language: 'fa',
          sprintf: require('sprintf-js').sprintf,

          //eventHub: new Vue()
      };
    },
    methods: {
        __: function (state, getters) {
            let dictionary = {
                'Address': {'en': '...', 'fa': 'آدرس'},
                'Accept law': {'en': '...', 'fa': 'ضوابط شرکت در دوره های آموزشی را مطالعه کرده و می پذیرم.'},
                'Application Name': {'en': '...', 'fa': 'سیستم جامع مدیریت آموزش مجتمع فنی تهران'},
                'Birth Date': {'en': '...', 'fa': 'تاریخ تولد'},
                'Birth Place': {'en': '...', 'fa': 'محل تولد'},
                'Certificate Inquiry': {'en': '...', 'fa': 'استعلام مدرک'},
                'Close': {'en': '...', 'fa': 'بستن'},
                'Cancel': {'en': '...', 'fa': 'انصراف'},
                'Cancel Presentation': {'en': '...', 'fa': 'انصراف از دوره'},
                'Courses': {'en': '...', 'fa': 'دوره ها'},
                'Comments': {'en': '...', 'fa': 'توضیحات'},
                'Department': {'en': '...', 'fa': 'دپارتمان'},
                'Departments': {'en': '...', 'fa': 'دپارتمان ها'},
                'Discount': {'en': '...', 'fa': 'تخفیف'},
                'Duration': {'en': '...', 'fa': 'مدت'},
                'Email': {'en': '...', 'fa': 'ایمیل'},
                'Enter Some Text Here For Search': {'en': '...', 'fa': 'عبارتی را برای جستجو وارد کنید!'},
                'Enrollment': {'en': '...', 'fa': 'ثبت نام'},
                'Error in Enrollment': {'en': '...', 'fa': 'متاسفانه خطایی صورت گرفت!'},
                'Error in Enrollment Full': {'en': '...', 'fa': 'متاسفانه در روند ثبت نام شما خطایی صورت گرفت لطفا اگر مبلغی از حساب شما کسر گردیده و به حساب شما برگشت نخورده است با مجتمع فنی تماس حاصل نمایید. در غیر اینصورت دوباره سعی کنید.'},
                'EN FName': {'en': '...', 'fa': 'نام لاتین'},
                'EN LName': {'en': '...', 'fa': 'نام خانوادگی لاتین'},
                'Full, Contact': {'en': '...', 'fa': 'ظرفیت تکمیل، تماس بگیرید.'},
                'Father Name': {'en': '...', 'fa': 'نام پدر'},
                'FName': {'en': '...', 'fa': 'نام'},
                'Gender': {'en': '...', 'fa': 'جنسیت'},
                'Home TEL.': {'en': '...', 'fa': 'تلفن منزل'},
                'Id': {'en': '...', 'fa': 'شناسه'},
                'Inquiry': {'en': '...', 'fa': 'استعلام'},
                'Identity Number': {'en': '...', 'fa': 'شماره شناسنامه'},
                'LName': {'en': '...', 'fa': 'نام خانوادگی'},
                'Mobile': {'en': '...', 'fa': 'موبایل'},
                'National Code': {'en': '...', 'fa': 'کد ملی'},
                'Number of Hours': {'en': '...', 'fa': 'تعداد ساعت'},
                'New': {'en': '...', 'fa': 'جدید'},
                'New Payment': {'en': '...', 'fa': 'پرداخت جدید'},
                'No certificate found whit this code "%s"!': {'en': '...', 'fa': 'مدرک متناسب با کد ملی "%s" یافت نشد!'},
                'Office TEL.': {'en': '...', 'fa': 'تلفن محل کار'},
                'Presentation': {'en': '...', 'fa': 'دوره'},
                'Presentation Title': {'en': '...', 'fa': 'عنوان دوره'},
                'Price(Rial)': {'en': '...', 'fa': 'شهریه (ریال)'},
                'Prequired': {'en': '...', 'fa': 'پیش نیاز'},
                'Prequireds': {'en': '...', 'fa': 'پیش نیازها'},
                'Presentations': {'en': '...', 'fa': 'دوره ها'},
                'Presentation Name': {'en': '...', 'fa': 'عنوان دوره'},
                'Presentation Days': {'en': '...', 'fa': 'روزهای تشکیل'},
                'Presentation Price': {'en': '...', 'fa': 'شهریه دوره'},
                'Presentation Total Price': {'en': '', 'fa': 'شهریه نهایی'},
                'Paid': {'en': '...', 'fa': 'پرداخت شده'},
                'Pay Date': {'en': '...', 'fa': 'تاریخ پرداخت'},
                'Pay Amount': {'en': '...', 'fa': 'مبلغ پرداختی'},
                'Pay Method': {'en': '...', 'fa': 'روش پرداخت'},
                'Print Reciepement': {'en': '...', 'fa': 'چاپ رسید'},
                'Presentations List': {'en': '...', 'fa': 'لیست دوره ها'},
                'Please fill all fields!': {'en': '...', 'fa': 'همه فیلدها باید تکمیل شوند!'},
                'Price with Discount(Rial)': {'en': '...', 'fa': 'شهریه با تخفیف (ریال)'},
                'Parvandeh': {'en': '...', 'fa': 'شماره پرونده'},
                'Row': {'en': '...', 'fa': 'ردیف'},
                'Read Law': {'en': '...', 'fa': 'مطالعه ضوابط شرکت در دوره های آموزشی'},
                'Return to Site': {'en': '...', 'fa': 'بازگشت به سایت'},
                'Register in Presentation': {'en': '...', 'fa': 'ثبت نام در دوره ی آموزشی'},
                'Register in New Presentation': {'en': '...', 'fa': 'ثبت نام در دوره جدید'},
                'Remain': {'en': '...', 'fa': 'مانده'},
                'Register Check': {'en': '...', 'fa': 'ثبت چک و وعده'},
                'Started, Contact': {'en': '...', 'fa': 'درحال برگزاری، تماس بگیرید.'},
                'Submit': {'en': '...', 'fa': 'ثبت'},
                'Submit and Select Presentation': {'en': '...', 'fa': 'ثبت و انتخاب دوره'},
                'Student Presentations List': {'en': '...', 'fa': 'لیست دوره های ثبت نام شده دانشجو'},
                'Student Presentation Payments': {'en': '...', 'fa': 'لیست پرداخت های دانشجو'},
                'Students': {'en': '...', 'fa': 'دانشجویان'},
                'Start Date': {'en': '...', 'fa': 'تاریخ شروع'},
                'TREF': {'en': '...', 'fa': 'کد رهگیری پرداخت'},
                'Your Enrollment Successfully done': {'en': '...', 'fa': 'ثبت نام شما در دوره زیر با موفقیت انجام شد!'},
                'ZIP Code': {'en': '...', 'fa': 'کد پستی'},
            };

            let self = this;
            let text = dictionary[arguments[0]] ? dictionary[arguments[0]][self.language] : arguments[0];
            return self.sprintf(text, Array.prototype.slice.call(arguments, 1));
        },
        farsiFormat(str, isdate, reverse) {
            if (!str)
                return str;

            str = str.toString();
            let standard = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
            let farsi = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

            if (isdate === true) {
                standard.push('-');
                farsi.push('/');
            }

            if (reverse === true)
                return str.replaceArray(farsi, standard);
            else
                return str.replaceArray(standard, farsi);
        },
        clone: function (obj) {
            if (null === obj || "object" !== typeof obj) return obj;
            let copy = obj.constructor();
            for (let attr in obj) {
                if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
            }
            return copy;
        },
        validate: function (formData) {
            for (let attr in formData) {
                if (formData.hasOwnProperty(attr) && !formData[attr]) {
                    return false;
                }
            }

            return true;
        },
        convertHtmlToText: function (html) {
            let div = document.createElement("div");
            div.innerHTML = html;
            return div.textContent || div.innerText || "";
        },
    },
    store: new Vuex.Store({
        state: {
            _debug: true,

            //_wordpress_url: 'http://127.0.0.1/projects/mft/public_html/',
            //_ajax_url: 'http://127.0.0.1/projects/mft/public_html/lms/api/',

            _wordpress_url: 'https://www.mftsk.com/',
            _ajax_url: 'https://www.mftsk.com/lms/api/',

            _csrf_token: '',
            _ajax_statuses: [],
            _role: 'guest',
            _presentations: new MyList(),
            _departments: new MyList(),
            _orders: new MyList(),
        },
        getters: {
            /**
             * items: read operation for list items in CRUD
             * @param state
             * @param getters
             * @returns {Function}
             */
            items: function (state, getters) {
                return function (key) {
                    return state['_' + key.toLowerCase()].data;
                };
            },

            /**
             * item: read operation for single item in CRUD
             * @param state
             * @param getters
             * @returns {Function}
             */
            item: function (state, getters) {
                return function (key, id) {
                    let list = state['_' + key.toLowerCase()];

                    if (list.data) {
                        return list.data.find(function (el) {
                            if (parseInt(el.id) === parseInt(id)) return el;
                        });
                    }
                    else
                        return null;
                };
            },

            /**
             *
             * @param state
             * @returns {Function}
             */
            getAjaxRunning: function (state) {
                return function (key) {
                    return state._ajax_statuses.indexOf(key) !== -1
                };
            },

            /**
             * isLoadedCompletely: check if a list completely gets from server or not
             * @param state
             * @param getters
             */
            isLoadedCompletely: function (state, getters) {
                return function (key) {
                    let var_state = state['_' + key.toLowerCase()];
                    return var_state.last_page === var_state.current_page;
                };
            },

            /**
             *
             * @param state
             * @returns {Function}
             */
            role: function (state) {
                return function () {
                    return state._role;
                };
            },
        },
        mutations: {
            /**
             * SETS: update operation for list items in CRUD
             * @param state
             * @param key
             * @param data
             * @param params
             * @constructor
             */
            SETS: function (state, {key, data, params}) {
                let list = state['_' + key.toLowerCase()];

                list.params = params;

                if (data === undefined) {
                    list.total = null;
                    list.last_page = null;
                    list.current_page = 1;
                    list.data = null;
                }
                else {
                    if (list.data === null)
                        list.data = [];

                    if (list.total === null) {
                        list.total = data.total;
                    }

                    list.last_page = data.last_page;
                    list.current_page = data.current_page;
                    if (list.current_page > list.last_page)
                        list.current_page = list.last_page;

                    let found = null;
                    data.data.forEach(function (el1, i) {
                        found = list.data.find(function (el2) {
                            if (parseInt(el1.id) === parseInt(el2.id)) return el2;
                        });
                        if (found)
                            list.data.splice(list.data.indexOf(found), 1, el1);
                        else
                            list.data.push(el1);
                    });
                }
            },

            /**
             * SETS: update operation for single item in CRUD
             * @param state
             * @param key
             * @param item
             * @constructor
             */
            SET: function (state, {key: key, item: item}) {
                let list = state['_' + key.toLowerCase()];

                let found = null;

                if (Array.isArray(list.data)) {
                    found = list.data.find(function (el) {
                        if (parseInt(el.id) === parseInt(item.id)) return el;
                    });
                }

                if (found)
                    list.data.splice(list.data.indexOf(found), 1, item);
                else {
                    list.data = [];
                    list.data.push(item);
                }
            },

            /**
             * SETS: create operation for single item in CRUD
             * @param state
             * @param key
             * @param data
             * @constructor
             */
            ADD: function (state, {key: key, item: item}) {
                let list = state['_' + key.toLowerCase()];

                if (list.data === null)
                    list.data = [];

                list.data.push(item);
            },

            /**
             * SETS: delete operation for single item in CRUD
             * @param state
             * @param key
             * @param id
             * @constructor
             */
            DELETE: function (state, {key: key, id: id}) {
                let list = state['_' + key.toLowerCase()];
                let found;

                found = list.data.find(function (el) {
                    if (parseInt(el.id) === parseInt(id)) return el;
                });

                if (found)
                    list.data.splice(list.data.indexOf(found), 1);
            },

            /**
             * SET_FIELDS: Set fields for list
             * @param state
             * @param key
             * @param fields
             * @constructor
             */
            SET_FIELDS: function (state, {key, fields}) {
                let list = state['_' + key.toLowerCase()];
                list.fields = fields;
            },
        },
        actions: {
            /**
             * GETS: raed operation and sync with server for list items in CRUD
             * @param commit
             * @param state
             * @param dispatch
             * @param getters
             * @param key
             * @param silent
             * @param more
             * @param params
             * @param data
             * @param callback
             * @constructor
             */
            GETS: function ({commit, state, dispatch, getters}, {key, silent, more, params, data, callback}) {
                let _key = key.toLowerCase();

                if (getters.getAjaxRunning(_key) === false) {
                    if (!data)
                        data = {};

                    // Get current params
                    if (more === true)
                        data.page = state['_' + key.toLowerCase()].current_page + 1;
                    else
                        data.page = 1;

                    if (!params) {
                        params = {
                            q: '',
                            filters: {},
                            order: {column: '', direction: ''}
                        };
                    }

                    data.filters = params.filters;
                    data.order = params.order;
                    data.q = params.q;

                    Dom7.ajax({
                        url: state._ajax_url + key.toLowerCase(),
                        method: 'GET',
                        data: data,
                        beforeSend: function (xhr) {
                            if (silent === false)
                                f7.showIndicator();

                            dispatch('setAjaxRunning', _key);
                            console.log('AJAX ' + _key + ' page: ' + data.page);
                        },
                        success: function (data, status, xhr) {
                            data = JSON.parse(data);
                            commit('SETS', {key: key, data: data, params: params});

                            if (callback)
                                window.setTimeout(callback, 100);
                        },
                        complete: function () {
                            dispatch('clearAjaxRunning', _key);

                            if (silent === false)
                                f7.hideIndicator();
                        }
                    });
                }
                else {
                    window.setTimeout(function () {
                        dispatch('GETS', {
                            key: key, silent: silent, more: more, params: params, data: data, callback: callback
                        });
                    }, 1000);
                }
            },

            /**
             * GET: raed operation and sync with server for single item in CRUD
             * @param commit
             * @param state
             * @param dispatch
             * @param getters
             * @param key
             * @param silent
             * @param id
             * @param callback
             * @param data
             * @constructor
             */
            GET: function ({commit, state, dispatch, getters}, {key, silent, id, callback, data}) {
                let _key = 'get/' + key.toLowerCase() + '/' + id;

                if (getters.getAjaxRunning(_key) === false) {
                    Dom7.ajax({
                        url: state._ajax_url + key.toLowerCase() + '/' + id,
                        method: 'GET',
                        data: data,
                        beforeSend: function (xhr) {
                            if (silent === false)
                                f7.showIndicator();

                            dispatch('setAjaxRunning', _key);
                            console.log('AJAX ' + _key);
                        },
                        success: function (data, status, xhr) {
                            data = JSON.parse(data);

                            if (getters.item(key, data.id))
                                commit('SET', {key: key, item: data});
                            else
                                commit('ADD', {key: key, item: data});

                            if (callback)
                                window.setTimeout(callback, 500);
                        },
                        complete: function () {
                            dispatch('clearAjaxRunning', _key);

                            if (silent === false)
                                f7.hideIndicator();
                        }
                    });
                }
                else {
                    window.setTimeout(function () {
                        dispatch('GET', {key: key, silent: silent, id: id, callback: callback, data: data});
                    }, 1000);
                }
            },

            /**
             * POST: create operation and sync with server for single item in CRUD
             * @param commit
             * @param state
             * @param dispatch
             * @param key
             * @param silent
             * @param data
             * @param callback
             * @constructor
             */
            POST: function ({commit, state, dispatch, getters}, {key, silent, data, callback}) {
                let _key = 'post/' + key.toLowerCase();

                if (getters.getAjaxRunning(_key) === false) {
                    Dom7.ajax({
                        url: state._ajax_url + key.toLowerCase(),
                        method: 'POST',
                        data: data,
                        beforeSend: function (xhr) {
                            if (silent === false)
                                f7.showIndicator();

                            dispatch('setAjaxRunning', _key);
                            console.log('AJAX ' + _key);
                        },
                        success: function (data, status, xhr) {
                            data = JSON.parse(data);
                            console.log(data);
                            commit('ADD', {key: key, item: data});

                            if (callback)
                                window.setTimeout(callback, 500);
                        },
                        complete: function () {
                            dispatch('clearAjaxRunning', _key);

                            if (silent === false)
                                vm.$f7.hideIndicator();
                        }
                    });
                }
                else {
                    window.setTimeout(function () {
                        dispatch('POST', {key: key, silent: silent, callback: callback, data: data});
                    }, 1000);
                }
            },

            /**
             * PUT: update operation and sync with server for single item in CRUD
             * @param commit
             * @param state
             * @param dispatch
             * @param key
             * @param silent
             * @param data
             * @param callback
             * @constructor
             */
            PUT: function ({commit, state, dispatch, getters}, {key, silent, data, callback, wp}) {
                let _key = 'put/' + key.toLowerCase() + '/' + data.id;

                let wp_string = wp ? '?wp=1' : '';
                if (getters.getAjaxRunning(_key) === false) {
                    Dom7.ajax({
                        url: state._ajax_url + key.toLowerCase() + '/' + data.id + wp_string,
                        method: 'PUT',
                        data: data,
                        beforeSend: function (xhr) {
                            if (silent === false)
                                f7.showIndicator();

                            dispatch('setAjaxRunning', _key);
                            console.log('AJAX ' + _key);
                        },
                        success: function (data, status, xhr) {
                            data = JSON.parse(data);
                            commit('SET', {key: key, item: data});
                            console.log(data);

                            if (callback)
                                window.setTimeout(callback, 500);
                        },
                        complete: function () {
                            dispatch('clearAjaxRunning', _key);

                            if (silent === false)
                                f7.hideIndicator();
                        }
                    });
                }
                else {
                    window.setTimeout(function () {
                        dispatch('PUT', {key: key, silent: silent, callback: callback, data: data});
                    }, 1000);
                }
            },

            /**
             * DELETE: delete operation and sync with server for single item in CRUD
             * @param commit
             * @param state
             * @param dispatch
             * @param key
             * @param silent
             * @param id
             * @param callback
             * @param data
             * @constructor
             */
            DELETE: function ({commit, state, dispatch, getters}, {key, silent, id, callback, data}) {
                let _key = 'delete/' + key.toLowerCase() + '/' + id;

                if (getters.getAjaxRunning(_key) === false) {
                    Dom7.ajax({
                        url: state._ajax_url + key.toLowerCase() + '/' + id,
                        method: 'DELETE',
                        data: data,
                        beforeSend: function (xhr) {
                            if (silent === false)
                                f7.showIndicator();

                            dispatch('setAjaxRunning', _key);
                            console.log('AJAX ' + _key);
                        },
                        success: function (data, status, xhr) {
                            commit('DELETE', {key: key, id: id});

                            if (callback)
                                window.setTimeout(callback, 500);
                        },
                        complete: function () {
                            dispatch('clearAjaxRunning', _key);

                            if (silent === false)
                                f7.hideIndicator();
                        }
                    });
                }
                else {
                    window.setTimeout(function () {
                        dispatch('DELETE', {key: key, silent: silent, id: id, callback: callback, data: data});
                    }, 1000);
                }
            },

            /**
             *
             * @param commit
             * @param state
             * @param key
             * @constructor
             */
            REFRESH: function ({commit, state}, key) {
                state['_' + key.toLowerCase()].clear();
            },

            /**
             *
             * @param state
             * @param dispatch
             * @param getters
             * @constructor
             */
            CSRF_TOKEN: function ({state, dispatch, getters}) {
                let _key = 'app/csrftoken';

                if (getters.getAjaxRunning(_key) === false) {
                    Dom7.ajax({
                        url: state._ajax_url + 'app/csrftoken',
                        method: 'GET',
                        beforeSend: function (xhr) {
                            dispatch('setAjaxRunning', _key);
                            console.log('AJAX CSRF_TOKEN');
                        },
                        success: function (data, status, xhr) {
                            state._csrf_token = data;

                            window.setTimeout(function () {
                                dispatch('CSRF_TOKEN');
                            }, 600000);
                        },
                        complete: function () {
                            dispatch('clearAjaxRunning', _key);
                        }
                    });
                }
                else {
                    window.setTimeout(function () {
                        dispatch('CSRF_TOKEN');
                    }, 1000);
                }
            },

            /**
             *
             * @param state
             * @param dispatch
             * @param key
             */
            setAjaxRunning: function ({state, dispatch}, key) {
                dispatch('clearAjaxRunning', key);
                state._ajax_statuses.push(key);
            },

            /**
             *
             * @param state
             * @param dispatch
             * @param key
             */
            clearAjaxRunning: function ({state, dispatch}, key) {
                state._ajax_statuses.splice(state._ajax_statuses.indexOf(key), 1);
            },

            /**
             *
             * @param commit
             * @param state
             * @param dispatch
             * @param getters
             * @param task
             * @param silent
             * @param data
             * @param callback
             * @param wp
             * @constructor
             */
            DO: function ({commit, state, dispatch, getters}, {task, silent, data, callback, wp}) {
                let _key = 'do/' + task.toLowerCase();

                let wpstring = (wp === true) ? '?wp=1' : '';
                if (getters.getAjaxRunning(_key) === false) {
                    Dom7.ajax({
                        url: state._ajax_url + task.toLowerCase() + wpstring,
                        method: 'POST',
                        data: data,
                        beforeSend: function (xhr) {
                            if (silent === false)
                                f7.showIndicator();

                            dispatch('setAjaxRunning', _key);
                            console.log('AJAX ' + _key);
                        },
                        success: function (data, status, xhr) {
                            try {
                                data = JSON.parse(data);
                            }
                            catch(err) {

                            }

                            if (callback)
                                window.setTimeout(function () {
                                    callback(data);
                                }, 500);
                        },
                        complete: function () {
                            dispatch('clearAjaxRunning', _key);

                            if (silent === false)
                                f7.hideIndicator();
                        }
                    });
                }
                else {
                    window.setTimeout(function () {
                        dispatch('DO', {key: key, task: task, silent: silent, callback: callback, data: data});
                    }, 1000);
                }
            },
        }
    })
});



// WEBPACK FOOTER //
// ./src/main.js